module.exports = __webpack_public_path__ + "img/idea_c.981b0993.svg";